import React from 'react'

import {css} from '../../theme/css'
import {createSvgIcon} from '../utils'

const root = css`
  block-size: 32px;
  inline-size: 162px;
`

export default createSvgIcon(
  <>
    <g clipPath="url(#clip0_9666_46531)">
      <mask
        height="29"
        id="mask0_9666_46531"
        maskUnits="userSpaceOnUse"
        style={{maskType: 'alpha'}}
        width="28"
        x="0"
        y="2"
      >
        <circle cx="14" cy="16.5" fill="white" r="14" />
      </mask>
      <g mask="url(#mask0_9666_46531)">
        <rect fill="#FC3F1D" height="28" transform="translate(0 2.5)" width="28" />
        <path
          d="M16.0644 10.3405H14.6476C12.2186 10.3405 11.0042 11.555 11.0042 13.3767C11.0042 15.4008 11.8138 16.4128 13.6355 17.6273L15.0524 18.6393L11.0042 24.914H7.76562L11.6114 19.2465C9.3849 17.6273 8.17044 16.2104 8.17044 13.5791C8.17044 10.3405 10.3969 8.11401 14.6476 8.11401H18.8982V24.914H16.0644V10.3405Z"
          fill="white"
        />
      </g>
    </g>
    <mask
      height="29"
      id="mask1_9666_46531"
      maskUnits="userSpaceOnUse"
      style={{maskType: 'luminance'}}
      width="28"
      x="32"
      y="2"
    >
      <path
        d="M46 2.5H46C38.268 2.5 32 8.768 32 16.5V16.5C32 24.232 38.268 30.5 46 30.5H46C53.732 30.5 60 24.232 60 16.5V16.5C60 8.768 53.732 2.5 46 2.5Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask1_9666_46531)">
      <path
        d="M45.9961 2.49829H45.9961C38.2641 2.49829 31.9961 8.76629 31.9961 16.4983V16.4983C31.9961 24.2303 38.2641 30.4983 45.9961 30.4983H45.9961C53.7281 30.4983 59.9961 24.2303 59.9961 16.4983V16.4983C59.9961 8.76629 53.7281 2.49829 45.9961 2.49829Z"
        fill="black"
      />
      <mask
        height="39"
        id="mask2_9666_46531"
        maskUnits="userSpaceOnUse"
        style={{maskType: 'alpha'}}
        width="37"
        x="23"
        y="-3"
      >
        <path
          d="M24.903 7.26195L40.6346 -1.99199C41.3887 -2.43561 42.3241 -2.43561 43.0782 -1.99199L58.81 7.26195C59.546 7.69493 59.9979 8.48511 59.9979 9.33906V23.657C59.9979 24.5107 59.546 25.301 58.81 25.734L43.0782 34.9879C42.3241 35.4315 41.3887 35.4315 40.6346 34.9879L24.903 25.734C24.1669 25.301 23.7148 24.5107 23.7148 23.657V9.33906C23.7148 8.48511 24.1669 7.69493 24.903 7.26195Z"
          fill="#C4C4C4"
        />
      </mask>
      <g mask="url(#mask2_9666_46531)">
        <path
          d="M41.8564 -2.70923L23.7148 7.96227L41.8564 18.6338L59.9979 7.96227L41.8564 -2.70923Z"
          fill="url(#paint0_linear_9666_46531)"
        />
        <path
          d="M23.7148 25.0365V7.9624L41.8564 18.6339V35.7083L23.7148 25.0365Z"
          fill="url(#paint1_radial_9666_46531)"
        />
        <path
          d="M60.0009 25.0369V7.9624L41.8594 18.6339V35.7083L60.0009 25.0369Z"
          fill="url(#paint2_radial_9666_46531)"
        />
        <path
          clipRule="evenodd"
          d="M32.5473 -0.734375L52.9512 11.3977C53.3496 11.6346 53.5938 12.064 53.5938 12.5275V33.5732H48.2582V15.5626C48.2582 15.0991 48.014 14.6698 47.6155 14.4328L29.8203 3.85189L32.5473 -0.734375Z"
          fill="url(#paint3_radial_9666_46531)"
          fillRule="evenodd"
        />
      </g>
      <path
        clipRule="evenodd"
        d="M37.0752 7.3041L37.5433 7.10403L39.4165 8.17104L40.2862 7.70422L38.4131 6.63721L38.8812 6.37046L35.8711 5.63689L37.0752 7.3041ZM39.2828 6.10371L39.7509 5.83696L41.6241 6.90396L42.5605 6.50385L40.6875 5.37014L41.1558 5.10339L38.1454 4.43652L39.2828 6.10371ZM39.3495 8.63785L43.3633 6.43715L43.7646 6.7039L39.7509 8.9046L39.3495 8.63785Z"
        fill="black"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M44.0394 11.5669C42.9826 10.8386 43.1146 9.77922 44.2375 9.18334C45.3603 8.52125 47.1436 8.65366 48.1342 9.38197C48.9928 9.97785 48.9268 10.971 49.125 12.4276C49.125 12.56 48.9928 12.6262 48.7947 12.6262C47.0774 12.2952 45.096 12.229 44.0394 11.5669ZM46.9454 11.1034C47.4738 10.8386 47.4738 10.3089 47.0114 9.97785C46.549 9.64679 45.7565 9.5806 45.2281 9.91164C44.6997 10.1765 44.6997 10.7062 45.1622 11.0372C45.6244 11.302 46.4171 11.3683 46.9454 11.1034Z"
        fill="black"
        fillRule="evenodd"
      />
      <path
        d="M52.5202 14.4141L50.9897 15.266L50.8064 15.8833L51.376 15.5823L50.6117 17.7576L50.8064 16.1774L50.2575 16.4579L50.4172 15.6234L49.125 16.3621C49.1297 16.5514 49.1445 17.0557 49.1666 17.5592C49.2362 19.3035 50.262 19.3311 50.5993 19.292C50.6026 19.5233 50.6854 20.3247 50.4769 20.784C50.2684 21.2433 49.8884 21.363 49.5549 21.5953C49.3759 21.7199 49.4721 21.9812 49.8345 21.7972C50.1968 21.6132 51.5112 20.8182 51.9452 20.6079C52.1674 20.5001 52.2009 20.1929 51.8473 20.3502C50.8721 20.784 50.9897 20.0416 50.9897 19.7784C50.9897 19.5151 50.9856 19.4466 50.9897 19.1289C52.4871 17.1695 52.6341 15.1693 52.5202 14.4141Z"
        fill="black"
      />
      <path
        clipRule="evenodd"
        d="M49.125 26.5502L49.5296 26.3488V28.6298L50.3389 28.1603V25.8793L50.7435 25.6779L49.9343 23.5983L49.125 26.5502ZM51.0808 25.4768L51.4854 25.2754V27.5564L52.2947 27.0869V24.8059L52.6995 24.6045L51.8226 22.4578L51.0808 25.4768ZM49.125 29.3679L52.6319 27.3553V27.892L49.125 29.9046V29.3679Z"
        fill="black"
        fillRule="evenodd"
      />
    </g>
    <path
      d="M64.125 28.625V22.65H65.3C65.7 21.9833 65.9833 21.025 66.15 19.775C66.3333 18.5083 66.4667 16.8417 66.55 14.775L66.8 7.625H77V22.65H78.625V28.625H75.8V25H66.95V28.625H64.125ZM69.4 15.175C69.3667 16.2083 69.3167 17.125 69.25 17.925C69.1833 18.725 69.1 19.425 69 20.025C68.9167 20.625 68.8167 21.1417 68.7 21.575C68.5833 21.9917 68.4583 22.35 68.325 22.65H73.975V9.975H69.575L69.4 15.175ZM85.4367 12.175C86.2534 12.175 87.0034 12.3167 87.6867 12.6C88.3701 12.8833 88.9534 13.3083 89.4367 13.875C89.9201 14.425 90.2951 15.1083 90.5617 15.925C90.8451 16.725 90.9867 17.65 90.9867 18.7C90.9867 19.75 90.8451 20.6833 90.5617 21.5C90.2951 22.3167 89.9201 23.0083 89.4367 23.575C88.9534 24.125 88.3701 24.5417 87.6867 24.825C87.0034 25.1083 86.2534 25.25 85.4367 25.25C84.6201 25.25 83.8701 25.1083 83.1867 24.825C82.5034 24.5417 81.9201 24.125 81.4367 23.575C80.9534 23.0083 80.5701 22.325 80.2867 21.525C80.0201 20.7083 79.8867 19.775 79.8867 18.725C79.8867 17.675 80.0201 16.7417 80.2867 15.925C80.5701 15.1083 80.9534 14.425 81.4367 13.875C81.9201 13.3083 82.5034 12.8833 83.1867 12.6C83.8701 12.3167 84.6201 12.175 85.4367 12.175ZM85.4367 22.9C86.2701 22.9 86.8867 22.5667 87.2867 21.9C87.7034 21.2333 87.9117 20.1667 87.9117 18.7C87.9117 17.2333 87.7034 16.175 87.2867 15.525C86.8867 14.8583 86.2701 14.525 85.4367 14.525C84.6034 14.525 83.9784 14.8583 83.5617 15.525C83.1617 16.1917 82.9617 17.2583 82.9617 18.725C82.9617 20.1917 83.1617 21.2583 83.5617 21.925C83.9784 22.575 84.6034 22.9 85.4367 22.9ZM98.3844 25.25C96.3844 25.25 94.901 24.6917 93.9344 23.575C92.9677 22.4583 92.4844 20.8417 92.4844 18.725C92.4844 17.775 92.601 16.9 92.8344 16.1C93.0844 15.2833 93.451 14.5917 93.9344 14.025C94.4344 13.4417 95.0427 12.9917 95.7594 12.675C96.476 12.3417 97.3094 12.175 98.2594 12.175C99.0094 12.175 99.651 12.2333 100.184 12.35C100.718 12.45 101.143 12.5917 101.459 12.775V15.3C101.159 15.1167 100.751 14.9417 100.234 14.775C99.7177 14.6083 99.1677 14.525 98.5844 14.525C97.601 14.525 96.851 14.875 96.3344 15.575C95.8177 16.2583 95.5594 17.2833 95.5594 18.65C95.5594 19.95 95.7927 20.9833 96.2594 21.75C96.726 22.5167 97.4927 22.9 98.5594 22.9C99.1927 22.9 99.7344 22.825 100.184 22.675C100.651 22.525 101.076 22.3167 101.459 22.05V24.475C100.743 24.9917 99.7177 25.25 98.3844 25.25ZM109.183 14.775V25H106.208V14.775H102.708V12.425H112.683V14.775H109.183ZM120.869 19.275H120.444C119.161 19.275 118.244 19.425 117.694 19.725C117.144 20.0083 116.869 20.5083 116.869 21.225C116.869 21.7583 117.019 22.1917 117.319 22.525C117.636 22.8417 118.111 23 118.744 23C119.278 23 119.719 22.9083 120.069 22.725C120.419 22.525 120.686 22.2833 120.869 22V19.275ZM123.844 21.925C123.844 22.9583 123.894 23.9833 123.994 25H121.094C121.044 24.8667 120.994 24.7083 120.944 24.525C120.911 24.3417 120.886 24.1667 120.869 24H120.744C120.461 24.3 120.094 24.575 119.644 24.825C119.194 25.0583 118.536 25.175 117.669 25.175C116.519 25.175 115.586 24.8333 114.869 24.15C114.169 23.4667 113.819 22.4833 113.819 21.2C113.819 19.9167 114.344 18.925 115.394 18.225C116.444 17.5083 118.111 17.15 120.394 17.15H120.869V16.45C120.869 15.7667 120.703 15.2917 120.369 15.025C120.036 14.7417 119.511 14.6 118.794 14.6C118.411 14.6 118.019 14.6417 117.619 14.725C117.219 14.7917 116.836 14.8833 116.469 15C116.119 15.1167 115.786 15.25 115.469 15.4C115.169 15.55 114.919 15.7 114.719 15.85V13.375C115.169 13.1083 115.769 12.85 116.519 12.6C117.269 12.35 118.144 12.225 119.144 12.225C120.728 12.225 121.903 12.5417 122.669 13.175C123.453 13.8083 123.844 14.8917 123.844 16.425V21.925ZM131.486 12.425C134.27 12.425 135.661 13.4917 135.661 15.625C135.661 16.375 135.461 16.9917 135.061 17.475C134.678 17.9417 134.145 18.275 133.461 18.475C134.311 18.6083 134.97 18.9167 135.436 19.4C135.903 19.8667 136.136 20.5167 136.136 21.35C136.136 22.55 135.72 23.4583 134.886 24.075C134.07 24.6917 132.92 25 131.436 25H126.236V12.425H131.486ZM129.136 19.65V22.8H131.186C131.786 22.8 132.261 22.675 132.611 22.425C132.961 22.1583 133.136 21.7333 133.136 21.15C133.136 20.6167 132.97 20.2333 132.636 20C132.303 19.7667 131.82 19.65 131.186 19.65H129.136ZM129.136 14.625V17.475H131.036C131.603 17.475 132.036 17.35 132.336 17.1C132.653 16.85 132.811 16.5083 132.811 16.075C132.811 15.1083 132.253 14.625 131.136 14.625H129.136ZM141.101 18.925V25H138.126V12.425H141.101V18.325L145.301 12.425H148.301L144.101 18.325L148.876 25H145.501L141.101 18.925ZM156.685 19.275H156.26C154.976 19.275 154.06 19.425 153.51 19.725C152.96 20.0083 152.685 20.5083 152.685 21.225C152.685 21.7583 152.835 22.1917 153.135 22.525C153.451 22.8417 153.926 23 154.56 23C155.093 23 155.535 22.9083 155.885 22.725C156.235 22.525 156.501 22.2833 156.685 22V19.275ZM159.66 21.925C159.66 22.9583 159.71 23.9833 159.81 25H156.91C156.86 24.8667 156.81 24.7083 156.76 24.525C156.726 24.3417 156.701 24.1667 156.685 24H156.56C156.276 24.3 155.91 24.575 155.46 24.825C155.01 25.0583 154.351 25.175 153.485 25.175C152.335 25.175 151.401 24.8333 150.685 24.15C149.985 23.4667 149.635 22.4833 149.635 21.2C149.635 19.9167 150.16 18.925 151.21 18.225C152.26 17.5083 153.926 17.15 156.21 17.15H156.685V16.45C156.685 15.7667 156.518 15.2917 156.185 15.025C155.851 14.7417 155.326 14.6 154.61 14.6C154.226 14.6 153.835 14.6417 153.435 14.725C153.035 14.7917 152.651 14.8833 152.285 15C151.935 15.1167 151.601 15.25 151.285 15.4C150.985 15.55 150.735 15.7 150.535 15.85V13.375C150.985 13.1083 151.585 12.85 152.335 12.6C153.085 12.35 153.96 12.225 154.96 12.225C156.543 12.225 157.718 12.5417 158.485 13.175C159.268 13.8083 159.66 14.8917 159.66 16.425V21.925Z"
      fill="#21201F"
    />
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_9666_46531"
        x1="41.1307"
        x2="42.3326"
        y1="-1.55671"
        y2="15.4375"
      >
        <stop stopColor="#FFE7C2" />
        <stop offset="1" stopColor="#E3B673" />
      </linearGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(41.0627 34.4273) rotate(-130.069) scale(20.0804 18.8137)"
        gradientUnits="userSpaceOnUse"
        id="paint1_radial_9666_46531"
        r="1"
      >
        <stop stopColor="#CA8D32" />
        <stop offset="1" stopColor="#F2C888" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(36.9543 28.6647) rotate(-27.4023) scale(22.9545 20.7441)"
        gradientUnits="userSpaceOnUse"
        id="paint2_radial_9666_46531"
        r="1"
      >
        <stop stopColor="#C4892F" />
        <stop offset="1" stopColor="#E6BE81" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(30.1165 4.22665) rotate(30.7627) scale(26.0797 19.0932)"
        gradientUnits="userSpaceOnUse"
        id="paint3_radial_9666_46531"
        r="1"
      >
        <stop stopColor="#FFF6E8" />
        <stop offset="0.677761" stopColor="#FFF9EF" />
        <stop offset="1" stopColor="#F0DBBC" />
      </radialGradient>
      <clipPath id="clip0_9666_46531">
        <rect fill="white" height="28" transform="translate(0 2.5)" width="28" />
      </clipPath>
    </defs>
  </>,
  'DostavkaLogoExpanded',
  {className: root, viewBox: '0 0 162 32'},
)
